import { useQuery } from 'react-query';
import { fetchSession } from 'modules/api';

export const useFetchSession = (offerCode: string, sessionId: string, config: any) =>
  useQuery('fetchSession', () => fetchSession(offerCode, sessionId), config);

export default {
  useFetchSession,
};
